export default __webpack_public_path__ + "static/media/bre.145490de.svg";